<template>
  <el-table-column :label="label" :prop="prop" :class-name="computedClass" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'テキスト中'
    },
    prop: {
      type: String,
      default: 'text_middle'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    className: String
  },
  computed: {
    computedClass: {
      get () {
        var clasz = ['text-middle']
        if (this.className) {
          clasz.push(this.className)
        }
        return clasz.join(' ')
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.text-middle {
      width: 7.5em;
    }
  }
}
</style>
